var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyList",style:(this.$props.styles)},[_c('van-image',{attrs:{"width":"180","height":"140","src":require('@/assets/img/empty.png')}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }